var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableFaq)?_c('NavButton',{attrs:{"label":_vm.label,"btn-id":"faq-button","icon":"question","image-src":_vm.imageSrc,"list":_vm.list},on:{"click":_vm.click}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }